import { MenuBreadcrumb as Crumb } from "../../../model/ivrMenu.utils";

function MenuBreadcrumb({ crumbs, onNavigate }: MenuBreadcrumbProps) {
  if (crumbs.length <= 1) return null;

  return (
    <div className="flex items-center flex-wrap gap-1 mb-3 text-sm">
      {crumbs.map((crumb, i) => {
        const isCurrent = i === crumbs.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            <button
              type="button"
              className={`px-2 py-1 rounded-10 font-medium ${
                isCurrent
                  ? "text-primary bg-white-dark cursor-default"
                  : "text-gray-dark hover:bg-white-dark hover:text-primary"
              }`}
              disabled={isCurrent}
              onClick={() => onNavigate(crumb.path)}
            >
              {crumb.label}
            </button>
            {!isCurrent && <span className="text-gray">›</span>}
          </span>
        );
      })}
    </div>
  );
}

export default MenuBreadcrumb;

export type MenuBreadcrumbProps = {
  crumbs: Crumb[];
  onNavigate: (path: number[]) => void;
};
